const SinglePost = {
  init() {},

};

export default SinglePost;
